import { useQuery } from "@tanstack/react-query";
import { fetchResumoInstalacoes } from "./api";

export function useResumoInstalacoes() {
  return useQuery({
    queryKey: ["instalacoes", "resumo"],
    queryFn: fetchResumoInstalacoes,
  });
}
